import { rgba } from 'polished';
import { media } from 'src/common/styles/breakpoints';
import { typography } from 'src/common/styles/typography';
import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${media.w.min.px576(css`
    display: grid;
    grid-template-columns: 50% 50%; //somehow 1fr 1fr does not work
    grid-template-rows: min-content;
  `)}
`;

export const Heading = styled.h1`
  font-family: ${typography.fontFamilyDefault};
  font-size: 2.5rem;
  line-height: 2.6875rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  margin-top: 2.375rem;

  ${media.w.min.px576(css`
    font-size: 4.75rem;
    margin-top: 6.5rem;
    line-height: 5rem;
  `)}
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1.75rem;
  line-height: 2.25rem;
  font-weight: 700;
  color: ${({ theme }) => theme.text.primary};
  font-family: ${typography.fontFamilyDefault};
`;

export const SecondaryText = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 0.875rem;
  line-height: 1.1875rem;

  & > u {
    cursor: pointer;
  }
`;

export const SectionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1.5rem;

  ${media.w.min.px576(css`
    max-width: 24rem;
    margin-top: 2rem;
  `)}
`;

export const VerificationCard = styled.div`
  border-radius: 0.5rem;
  background-color: ${({ theme }) => rgba(theme.colors.grey2, 0.3)};
  padding: 1.5rem 0.75rem;
  display: flex;
  flex-direction: column;

  ${SecondaryText} {
    margin-top: 0.5rem;
  }
`;

export const ProcessState = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8125rem;
  margin-bottom: 1.8125rem;
`;

export const ProcessStateWrapper = styled.div`
  padding-left: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const ImageDesktop = styled.div`
  ${media.w.max.px576(css`
    display: none;
  `)}
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 180px;
    height: 45rem;
    width: 30.5rem;
    content: '';
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.colors.grey2};
    opacity: 0.3;
    z-index: -1;
  }

  svg {
    margin-top: 3.875rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SubsectionTitle = styled.h3`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 1.125rem;
  line-height: 1.9375rem;
  text-align: left;
  font-weight: bold;
  opacity: 0.7;
`;
